export default function reducer(state = {
  outlet: {}, // for OutletView
  store: {},
  relationships: {
    staff_members: []
  },
  newOrderAmount: '',
  fetching: false,
  fetched: false,
  errors: {},
}, action) {
  switch (action.type) {
    case 'GET_OUTLET_PENDING': {
      return {
        ...state,
        errors: {},
        fetching: true,
        fetched: false,
        outlet: {},
        store: {},
        relationships: {
          staff_members: []
        },
      };
    }
    case 'GET_OUTLET_FULFILLED': {
      const {data} = action.payLoad;
      return {
        ...state,
        fetching: false,
        fetched: true,
        errors: {},
        outlet: data,
        store: data.attributes,
        relationships: {
          staff_members: data.relationships ? data.relationships['staff-members'].data : [],
          groups: data.relationships && data.relationships.groups ? data.relationships.groups.data : []
        }
      };
    }
    case 'GET_OUTLET_REJECTED': {
      return {
        ...state,
        // errors: action.payLoad.data.error
        errors: ''
      };
    }
    case 'CLEAR_OUTLET_DELINK': {
      return {
        ...state,
        store: {},
        fetched: false,
        fetching: false
      };
    }
    default:
      return {
        ...state,
        errors: {}
      };
  }
}
